import { XOutlined } from '@ant-design/icons';

export default XOutlined;
